import React from 'react';
import { P1, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import DownloadAppstore from 'assets/download-appstore.svg';
import DownloadGooglePlay from 'assets/download-googleplay.svg';
import { Card } from 'styleguide/Card';
import { t } from 'translations/t';

export const RoutineDetailHevyCTACard = () => {
  return (
    <Card style={{ padding: Spacing.lg }}>
      <View style={{ alignItems: 'center' }}>
        <P1 style={{ paddingBottom: Spacing.sm }}>{t('web.routineDetail.saveRoutine')}</P1>
        <P2 style={{ paddingBottom: Spacing.md, textAlign: 'center' }} type="secondary">
          {t('web.routineDetail.saveRoutine.desc')}
        </P2>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: Spacing.md,
          }}
        >
          <a href="https://hevyapp.app.link/1TLxztjk2db">
            <DownloadAppstore />
          </a>
          <a href="https://hevyapp.app.link/d1yXlPlk2db">
            <DownloadGooglePlay />
          </a>
        </View>
      </View>
    </Card>
  );
};
